import { Stack } from '@mui/material';
import { memo, useEffect, useRef, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import NavList from './nav_list';

function NavSectionVertical({ data, sx, currentNav }) {
  const [openIndex, setOpenIndex] = useState(null);
  const { pathname } = useLocation();
  const syncedRef = useRef('');

  useEffect(() => {
    const syncKey = `${pathname}|${data.length}`;
    if (syncedRef.current === syncKey) {
      return;
    }
    syncedRef.current = syncKey;

    const isMatch = (url) => url && matchPath({ path: url, end: false }, pathname);
    const activeIndex = data.findIndex(
      (item) => isMatch(item.url) || item.children?.some((child) => isMatch(child.url)),
    );
    setOpenIndex(activeIndex === -1 ? null : activeIndex);
  }, [data, pathname]);

  const handleNavListToggle = (index, open) => {
    setOpenIndex((prevIndex) => (open ? index : null));
  };

  const renderContent = data.map((list, index) => {
    return (
      <NavList
        key={index}
        data={list}
        depth={0}
        hasChild={!!list.children}
        isSelected={currentNav}
        open={openIndex === index}
        onToggle={(open) => handleNavListToggle(index, open)}
        setOpenIndex={setOpenIndex}
        index={index}
      />
    );
  });

  return <Stack sx={sx}>{renderContent}</Stack>;
}

export default memo(NavSectionVertical);
